import { Component, Inject, Input, OnInit } from '@angular/core';
import { ROWITEM } from 'src/app/app.module';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNReport } from 'src/app/models/cnreport';
import { CNItem } from 'src/app/models/cnitem';

@ManageType('ReportRowComponent')
@Component({
  selector: 'app-report-row',
  templateUrl: './report-row.component.html',
  styleUrls: ['./report-row.component.scss']
})
export class ReportRowComponent implements OnInit {

  @Input() item: CNReport;

  private cacheContent = '';
  private cacheContentSummary = '';

  constructor(@Inject(ROWITEM) private injectedItem: CNReport) { }

  ngOnInit(): void {
    this.item = this.item || this.injectedItem;
//    console.log('Row Item', this.item);
    this.cacheContent = this.item.child$('stvaast_rapportconsultation_contenu')?.value;
    if (this.cacheContent) {
      this.cacheContentSummary = this.cacheContent.substring(0, 250);
    }
  }

  get contentSummary() {
    return this.cacheContentSummary;
  }

  get content() {
    return this.cacheContent;
  }

  get document() {
    return this.item.child$('stvaast_rapportconsultation_document');
  }

  get echo() {
    return this.item.child$('stvaast_rapportconsultation_echo');
  }
}
